import React from 'react';
import autoBind from 'react-autobind';
import { notifications } from '@mantine/notifications';

// Notification host. The toast UI is rendered by the <Notifications/> provider
// mounted in src/index.js; this component just exposes the legacy
// add(message, success) API (called via ref from root.addNotification).
class Notification extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();
    this.state = {};
    autoBind(this);
  }

  add(message, success) {
    notifications.show({
      message,
      color: success ? 'green' : 'red',
      autoClose: 6000,
    });
  }

  render() {
    return null;
  }
}

export default Notification;
